import React, { Component }from 'react';
import { Link } from 'react-router';
import { SkyLightStateless } from 'react-skylight';
import ReactDataGrid from 'react-data-grid';
import { Toolbar, Data } from 'react-data-grid-addons';
import { UI_HEIGHT } from '../Common/constants';
import { Grid, Row, Col, Panel, ButtonToolbar, Button, Table, Breadcrumb } from 'react-bootstrap';
import ContentWrapper from '../../components/Layout/ContentWrapper';
import Spinner from '../../components/Widgets/spinner';
import PaymentTermForm from '../../containers/Customers/paymentTermForm';
import checkPermission from '../Common/permissions';
import { Translate, Localize } from 'react-redux-i18n';
import { companyCodeTitle } from '../../actions/root_url';

class PaymentTerms extends Component {
    static contextTypes = {
        router: React.PropTypes.object
    };

    constructor() {
        super();
        this.state = {
            tableHeight: window.innerHeight - UI_HEIGHT.customersPage,

            rows: [],
            selectedRows: null,
            filters: {},
            sortColumn: null,
            sortDirection: null,
            paymentTermOpen: false
        };

        this.handleResize = this.handleResize.bind(this);
        this.openPaymentTerm = this.openPaymentTerm.bind(this);
        this.closePaymentTerm = this.closePaymentTerm.bind(this);
    }

    componentDidMount() {
        document.title = companyCodeTitle;
        window.addEventListener('resize', this.handleResize);
        this.props.fetchPaymentTerms();
    }

    componentDidUpdate() {
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.handleResize);
    }

    // Once paymentTerm is ready, reset state.

    componentWillReceiveProps(nextProps) {
        const PT = nextProps.paymentTerms;
        if (nextProps.paymentTerms && nextProps.paymentTerms != this.props.paymentTerms) {
            this.setState({
                rows: nextProps.paymentTerms
            });
        }
    }

    handleResize(e) {
        this.setState({tableHeight: window.innerHeight - UI_HEIGHT.customersPage});
    }

    openPaymentTerm() { this.setState({ paymentTermOpen: true }); }
    closePaymentTerm() { this.setState({ paymentTermOpen: false }); }

    // Helper function to render an icon for the stock statues of paymentTerm.

    renderIsEnabled(IsEnabled) {
        if (IsEnabled) return <span className="label label-success">Enabled</span>;
        else return <span className="label label-danger">Disabled</span>;
    }

    // Set paymentTerm being selected to be currentPaymentTerm and navigate user to the edit page

    setCurrentPaymentTerm(e) {
        e.preventDefault();
        const currentPaymentTerm = this.state.selectedRows[0];
        this.props.selectPaymentTerm(currentPaymentTerm);
        this.openPaymentTerm();
    }

    clickNew(e) {
        e.preventDefault();
        this.props.resetCurrentPaymentTerm();
        this.openPaymentTerm();
    }

    // Render the table head and bind it to the datatable plugin to show a sortable and searchable table.

    renderTable() {
      if (this.props.isLoading && !this.props.error) {
        return (
          <Spinner/>
        );
      }
      else if (this.props.error) {
        return (
          <ContentWrapper>
            <div className="alert alert-danger">
              {JSON.stringify(this.props.error)}
            </div>
          </ContentWrapper>
        );
      }
        else {
            // Parameters of the react-data-grid

            const getRows = () => {
                return Data.Selectors.getRows(this.state);
            }

            const getSize = () => {
                return getRows().length;
            }

            const rowGetter = rowIdx => {
                var rows = getRows();
                return rows[rowIdx];
            }

            // Column difinition

            const columns = [
                {
                    key: 'Name',
                    name: <Translate value="name" />,
                    resizable: true,
                    sortable: true,
                    filterable: true,
                    width: 150,
                },
                {
                    key: 'Description',
                    name: <Translate value="description" />,
                    resizable: true,
                    sortable: true,
                    filterable: true,
                    width: 150,
                },
                {
                    key: 'TermDays',
                    name: <Translate value="term_days" />,
                    resizable: true,
                    sortable: true,
                    filterable: true,
                    width: 50,
                },
                {
                    key: 'Termtype',
                    name: <Translate value="term_type" />,
                    resizable: true,
                    sortable: true,
                    filterable: true,
                    width: 100,
                }
            ]

            // Handle the sortable function

            const handleGridSort = (sortColumn, sortDirection) => {
                var state = Object.assign({}, this.state, { sortColumn: sortColumn, sortDirection: sortDirection });
                this.setState(state);
            }

            const handleFilterChange = filter => {
                let newFilters = Object.assign({}, this.state.filters);
                if (filter.filterTerm) {
                    newFilters[filter.column.key] = filter;
                } else {
                    delete newFilters[filter.column.key];
                }
                this.setState({ filters: newFilters });
            }


            // Handle the editable function

            const handleRowUpdated = e => {
                // merge updated row with current row and rerender by setting state
                let rows = getRows();
                Object.assign(rows[e.rowIdx], e.updated);
                this.setState({ rows: rows });
            }

            // Handle the Dragable cell function

            const handleCellDrag = e => {
                let rows = this.state.rows.slice(0);
                for (let i = e.fromRow; i <= e.toRow; i++) {
                    let rowToUpdate = rows[i];
                    rowToUpdate[e.cellKey] = e.value;
                }
                this.setState({ rows: rows });
            }

            const handleDragHandleDoubleClick = e => {
                var rows = this.state.rows.map(function (r) {
                    return Object.assign({}, r);
                });
                var column = columns[e.idx - 1];
                for (var i = e.rowIdx; i <= rows.length - 1; i++) {
                    var rowToUpdate = rows[i];
                    rowToUpdate[column.key] = e.rowData[column.key];
                }
                this.setState({ rows: rows });
            }

            const onRowSelect = rows => {
                this.setState({ selectedRows: rows });
            }

            return (
              // React Table Payment Terms List
                <Row>
                  <Col sm={ 12 }>
                    <div id="PaymentTerms-dataGrid1">
                      <ReactDataGrid
                        rowKey='PaymentTerm_id'
                        enableCellSelect={true}
                        onGridSort={handleGridSort}
                        toolbar={<Toolbar enableFilter={true}/>}
                        onAddFilter={handleFilterChange}
                        columns={columns}
                        rowHeight={25}
                        headerRowHeight={45}
                        rowGetter={rowGetter}
                        rowsCount={getSize() }
                        minHeight={this.state.tableHeight}
                        enableRowSelect='single'
                        onRowUpdated={handleRowUpdated}
                        onDragHandleDoubleClick={handleDragHandleDoubleClick}
                        onCellsDragged={handleCellDrag}
                        onRowSelect={onRowSelect} />
                    </div>
                  </Col>
                </Row>
            )
        }
    }

    formTitle() {
        if (this.props.currentPaymentTerm) return <Translate value="edit_paymentTerm" />;
        else return <Translate value="create_payment_term" />;
    }

    render() {
      let createDialogStyle = {
          height: '300px',
          width: '600px',
          marginLeft: '-10%',
      };
      console.log(this.state.selectedRows);
      let height = (this.state.tableHeight + 70).toString();
      let tableCollapseFix = {height: height}
        return (
          //---------------
          // Begin HTML
          //---------------
          <ContentWrapper>
            {/* Nav Trail */}
            <Breadcrumb>
              <Breadcrumb.Item>
                <Translate value="general_management" />
              </Breadcrumb.Item>
              <Breadcrumb.Item active="true">
                <Translate value="payment_term" />
              </Breadcrumb.Item>
            </Breadcrumb> {/* End Nav Trail */}
            <Grid fluid="true" id="payment-terms" >
              {/* <h1><Translate value="manage_payment_terms" /></h1> */}
              <Row>
                <Col sm={12}>
                  <Panel className="position-relative" style={tableCollapseFix}>
                    <ButtonToolbar className="table-buttons">
                      <Button
                          bsStyle="success"
                          type="submit"
                          onClick={(event) => { this.clickNew(event) } }
                          disabled={!checkPermission("add_payment_term")}>
                            <em className="fa fa-plus" /><Translate value="create" />
                      </Button>
                      <Button
                          bsStyle="warning"
                          type="button"
                          onClick={(event) => { this.setCurrentPaymentTerm(event) } }
                          disabled={!this.state.selectedRows || this.state.selectedRows.length != 1 || !checkPermission("change_payment_term")}>
                            <em className="fa fa-pencil"/><Translate value="edit" />
                      </Button>
                    </ButtonToolbar>
                    {/* Payment Terms Table */}
                    {this.renderTable() }
                  </Panel>
                </Col>
              </Row>
            </Grid>
              <SkyLightStateless dialogStyles={createDialogStyle} isVisible={this.state.paymentTermOpen} onCloseClicked={() => { this.closePaymentTerm() } } title={this.formTitle() }>
                  <PaymentTermForm closePT={this.closePaymentTerm} />
              </SkyLightStateless>
          </ContentWrapper>
          //---------------
          //End HTML
          //---------------

        );
    }
}



export default PaymentTerms;



// WEBPACK FOOTER //
// ./master/jsx/components/PaymentTerms/paymentTerms.jsx